module.exports = __webpack_public_path__ + "img/logo_dark.d2ccf919.svg";